import { render, staticRenderFns } from "./SatelliteImagery.vue?vue&type=template&id=53be8c4d&scoped=true&"
import script from "./SatelliteImagery.vue?vue&type=script&lang=js&"
export * from "./SatelliteImagery.vue?vue&type=script&lang=js&"
import style0 from "./SatelliteImagery.vue?vue&type=style&index=0&id=53be8c4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be8c4d",
  null
  
)

export default component.exports